import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["content", "hovered", "ids", "isCondensed", "inlineContent", "linkLabel", "pressed", "previewLabel", "options", "title", "onClick", "onSelect", "styleSheet"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import { compose, setDisplayName, setPropTypes, withProps } from 'recompose';
import omitProps from '@hocs/omit-props';
import wrapOverridableComponent from '@bubble-ui/hoc-wrap-overridable-component';
import { withDesignVersion } from '@bubble-ui/provider-design-version';
import { withDesignContext } from '@klarna/designtokens';
import Badge from '@bubble-ui/molecule-badge';
import LineBreak from '@bubble-ui/primitive-line-break';
import PreviewLink from '@bubble-ui/atom-preview-link';
import Text from '@bubble-ui/primitive-text';
import View from '@bubble-ui/primitive-view';
import Touchable from '@bubble-ui/primitive-touchable';
import SelectorDirect from '@bubble-ui/molecule-selector-direct';
import { Separator } from '@bubble-ui/atom-separator';
import reformatObfuscation from '@bubble-ui/util-reformat-obfuscation';
import { isNative } from '@bubble-ui/util-platform';
import withDeprecationWarning from '@bubble-ui/hoc-with-deprecation-warning';
import { defaultDesignTokens } from './defaultDesignTokens';
import { getDefaultStyleSheet } from './getDefaultStyleSheet';
import { getIds } from './getIds';
var PreviewWithOptions = _ref => {
  var {
      content,
      hovered,
      ids,
      isCondensed,
      inlineContent,
      linkLabel,
      pressed,
      previewLabel,
      options,
      title,
      onClick,
      onSelect,
      styleSheet: {
        rootStyle,
        touchableStyle,
        paragraphWrapperStyle,
        previewTopStyle,
        previewShrink,
        titleStyle,
        inlineContentStyle,
        linkWrapperStyle,
        headerContentStyle,
        selectorWrapperStyle,
        separatorWrapperStyle,
        rowStyle,
        paragraphSecondaryBlockStyle,
        paragraphSecondaryLightStyle,
        paragraphSecondaryCorrectFootprintLightStyle,
        spacerHorizontalMediumStyle,
        spacerVerticalExtraExtraSmallStyle
      }
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var firstContentItem = content && isCondensed ? content.shift() : '';
  return /*#__PURE__*/React.createElement(View, _extends({}, props, {
    id: ids.root,
    style: rootStyle
  }), /*#__PURE__*/React.createElement(Touchable, {
    id: ids.touchablePreview,
    style: touchableStyle,
    onClick: onClick
  }, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, {
    style: previewTopStyle
  }, previewLabel != null ? /*#__PURE__*/React.createElement(View, {
    id: ids.label,
    style: previewShrink
  }, /*#__PURE__*/React.createElement(Badge, {
    backgroundColorToken: "colors/backgrounds/subtle-floating",
    textColorToken: "colors/text/default"
  }, previewLabel)) : /*#__PURE__*/React.createElement(View, {
    id: ids.header,
    style: previewShrink
  }, /*#__PURE__*/React.createElement(Text, {
    id: ids.title,
    numberOfLines: 0,
    tag: "h2",
    style: titleStyle
  }, title), firstContentItem ? /*#__PURE__*/React.createElement(Text, {
    style: inlineContentStyle
  }, firstContentItem) : null, inlineContent ? /*#__PURE__*/React.createElement(Text, {
    style: inlineContentStyle
  }, inlineContent) : null), /*#__PURE__*/React.createElement(View, {
    style: linkWrapperStyle,
    id: ids.linkWrapper
  }, /*#__PURE__*/React.createElement(Text, _extends({}, isNative ? {
    numberOfLines: 0
  } : {}, {
    tag: "paragraph",
    style: paragraphSecondaryBlockStyle,
    id: ids.linkParagraph
  }), /*#__PURE__*/React.createElement(PreviewLink, {
    hovered: hovered,
    id: ids.link,
    pressed: pressed
  }, linkLabel)))), previewLabel != null && /*#__PURE__*/React.createElement(View, {
    id: ids.header,
    style: rowStyle
  }, /*#__PURE__*/React.createElement(Text, {
    id: ids.title,
    numberOfLines: 0,
    tag: "h2",
    style: titleStyle
  }, title), Boolean(firstContentItem) && /*#__PURE__*/React.createElement(View, {
    style: rowStyle
  }, /*#__PURE__*/React.createElement(View, {
    style: spacerHorizontalMediumStyle
  }), /*#__PURE__*/React.createElement(View, {
    id: ids.firstItemContentWrapper,
    style: headerContentStyle
  }, /*#__PURE__*/React.createElement(Text, _extends({}, isNative ? {
    numberOfLines: 0
  } : {}, {
    tag: "paragraph",
    style: paragraphSecondaryCorrectFootprintLightStyle,
    id: ids.contentParagraph
  }), firstContentItem)))), content && !isCondensed && !inlineContent && /*#__PURE__*/React.createElement(View, {
    id: ids.contentWrapper,
    style: paragraphWrapperStyle
  }, /*#__PURE__*/React.createElement(Text, _extends({}, isNative ? {
    numberOfLines: 0
  } : {}, {
    tag: "paragraph",
    style: paragraphSecondaryLightStyle,
    id: ids.contentParagraph
  }), content.map((line, index) => {
    var isLast = index === content.length - 1;
    return /*#__PURE__*/React.createElement(Text, {
      id: ids.line(index),
      key: index,
      style: {
        fontSize: 16
      }
    }, line, !isLast && /*#__PURE__*/React.createElement(LineBreak, null));
  }))), /*#__PURE__*/React.createElement(View, {
    style: spacerVerticalExtraExtraSmallStyle
  }))), options && options.length !== 0 ? /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, {
    id: ids.separatorWrapper,
    style: separatorWrapperStyle
  }, /*#__PURE__*/React.createElement(Separator, null)), /*#__PURE__*/React.createElement(View, {
    id: ids.selectorWrapper,
    style: selectorWrapperStyle
  }, /*#__PURE__*/React.createElement(SelectorDirect, {
    id: ids.selector,
    options: options,
    onSelect: onSelect
  }))) : undefined);
};
export default compose(setDisplayName('PreviewWithOptions'), setPropTypes({
  content: PropTypes.array,
  linkLabel: PropTypes.string,
  previewLabel: PropTypes.string,
  title: PropTypes.string,
  id: PropTypes.string,
  inlineContent: PropTypes.string,
  isCondensed: PropTypes.bool,
  isObfuscated: PropTypes.bool,
  options: PropTypes.array,
  onClick: PropTypes.func,
  onSelect: PropTypes.func,
  sandwich: PropTypes.bool
}), withDesignVersion, withDesignContext(defaultDesignTokens),
// ⚠️ THIS COMPONENT SUPPORTS STYLE SHEET OVERRIDES ⚠️
// Keep passing all props to the style sheet, even if we don't use them ourselves
wrapOverridableComponent('PreviewWithOptions', getDefaultStyleSheet), withProps(getIds), withProps(_ref2 => {
  var {
    isObfuscated,
    title,
    content
  } = _ref2;
  return _objectSpread({
    title: isObfuscated ? reformatObfuscation(title) : title
  }, content !== undefined ? {
    content: isObfuscated ? content.map(reformatObfuscation) : content
  } : {});
}), omitProps('id', 'sandwich', 'designContext', 'designVersion', 'omitFirstLine', 'omitLastLine', 'isObfuscated', 'keyboardFocused', 'focused'), withDeprecationWarning({
  name: 'PreviewWithOptions',
  removalDate: 'v6.0.0',
  useInstead: 'Preview'
}))(PreviewWithOptions);
//# sourceMappingURL=index.js.map